import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import SetupWarehouse from "../../../containers/modules/master/setup-warehouse";

export default function SetupWarehouseRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="setup-warehouse"
      // action={() => onRouteChanged()}
      index
      element={
        <AccessControl
          name={"Setup Warehouse List"}
          auth={authUser}
          component={() => <SetupWarehouse authUser={authUser} />}
        />
      }
    />
  );
}
